var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayCircle = function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M8.479 1.334C4.569 1.334 1.396 4.32 1.396 8s3.173 6.667 7.083 6.667S15.562 11.68 15.562 8 12.396 1.334 8.48 1.334m2.125 8.153L8.55 10.6c-.255.14-.539.207-.815.207-.283 0-.56-.067-.814-.207-.51-.28-.815-.773-.815-1.333V7.034c0-.554.305-1.054.815-1.334s1.119-.28 1.636 0l2.054 1.114c.51.28.814.773.814 1.333s-.304 1.06-.821 1.34"
  })));
};
export default SvgPlayCircle;